module.exports = __webpack_public_path__ + "img/descargalasya.252fc7e6.svg";